import { useState, useRef, useContext, useEffect } from 'react';
import { PaxContext } from '../../utils/context/checkoutContext';

export const CurrencySwitcher = () => {
  const [isOpen, setIsOpen] = useState(false);
  // Get currency and updateCurrency from PaxContext
  const { currency, updateCurrency }: any = useContext(PaxContext);

  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !(dropdownRef.current as any).contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const selectCurrency = (newCurrency: string) => {
    updateCurrency(newCurrency);
    setIsOpen(false);
  };

  const DollarIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 16 16"
      fill="none"
      className="group-hover:stroke-primary stroke-current"
    >
      <path
        d="M8 4V12M6 10.1213L6.586 10.5607C7.36667 11.1467 8.63267 11.1467 9.414 10.5607C10.1953 9.97467 10.1953 9.02533 9.414 8.43933C9.024 8.146 8.512 8 8 8C7.51667 8 7.03333 7.85333 6.66467 7.56067C5.92733 6.97467 5.92733 6.02533 6.66467 5.43933C7.402 4.85333 8.598 4.85333 9.33533 5.43933L9.612 5.65933M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <div className="relative inline-block text-left">
      <div>
        <div
          onClick={toggleDropdown}
          className="flex justify-center w-full font-medium hover:text-primary focus:outline-none items-center cursor-pointer gap-2 group"
        >
          {/* Display the current currency */}
          <span className="text-base text-black13 group-hover:text-primary font-semibold">
            {currency}
          </span>
          <DollarIcon />
        </div>
      </div>

      {isOpen && (
        <div
          ref={dropdownRef}
          className="origin-center bg-white absolute left-[-20px] mt-2 w-[94px] rounded-[10px] shadow border border-gray-200 focus:outline-none z-[100]"
        >
          <div className="py-1">
            <button
              onClick={() => selectCurrency('USD')}
              className={`px-4 py-2 text-sm flex justify-center w-full font-medium hover:text-primary focus:outline-none items-center cursor-pointer gap-2 group`}
            >
              <span className="text-base text-black13 group-hover:text-primary">
                USD
              </span>
              <DollarIcon />
            </button>
            <button
              onClick={() => selectCurrency('CAD')}
              className={`px-4 py-2 text-sm flex justify-center w-full font-medium hover:text-primary focus:outline-none items-center cursor-pointer gap-2 group`}
            >
              <span className="text-base text-black13 group-hover:text-primary">
                CAD
              </span>
              <DollarIcon />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
